import { Avatar, Box, Card, IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";

const RecentSubscriptionVisitUser = ({
  recentData,
  onClickRecentData,
  onClickRecentDelete,
}) => {
  return (
    <Grid container spacing={2}>
      {" "}
      {recentData?.map((user, index) => (
        <Grid
          size={{ lg: 4, md: 6, sm: 12, xs: 12 }}
          key={user.id}
          onClick={() => onClickRecentData(user)}
        >
          <Card variant="outlined">
            <Box
              display="flex"
              alignItems="center"
              flexWrap={{
                md: "nowrap",
                xs: "wrap",
              }}
              p={1}
              gap={2}
            >
              <Avatar
                variant="rounded"
                alt={user.name}
                src={require(`../../../assets/img/profiles/p${index + 1}.jpg`)}
                sx={{
                  width: 50,
                  height: 50,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    {user.name},{" "}
                    <Typography
                      fontSize={10}
                      color="text.secondary"
                      component="span"
                    >
                      {user?.age || "N/A"} yrs
                    </Typography>
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    {user?.mobile}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => onClickRecentDelete(user)}
                  sx={{
                    width: 25,
                    height: 25,
                  }}
                >
                  <DeleteIcon
                    sx={{
                      color: "#C04000",
                      "&:hover": {
                        color: "darkred",
                      },
                      width: 20,
                      height: 20,
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default RecentSubscriptionVisitUser;
